// @ts-nocheck
import { NextPage } from "next";
import { Container } from "../../components/atoms/Container";
import { Layout } from "../../layout/Layout";
import skills from "../../data/skills.json";
import simpleIcons from "simple-icons";
import { iconify } from "../../utils";
import ReactTooltip from "react-tooltip";
import Image from "next/image";
import education from "../../data/school.json";
import { Education } from "../../components/organisms/Education";
import { Button } from "../../components/atoms/Button";
import { Icon } from "../../components/atoms/Icon";

const wrapper: any = (sk = []): any =>
  sk.map((v: any) => {
    const ic: any = simpleIcons.Get(
      typeof v === "string" ? iconify(v) : iconify(v.icon)
    ) || {
      title: v,
      hex: "424242",
      component: <div>Cancel</div>,
    };

    return {
      alt: v.alt || v || ic.title,
      backgroundColor: v.backgroundColor || "#" + ic.hex,
      icon: ic.component || (
        <svg
          role="img"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          height="100%"
          width="100%"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <title>{ic.title}</title>
          <path d={ic.path} fill="white" />
        </svg>
      ),
    };
  });

let wrappedSkills: any = {};
Object.getOwnPropertyNames(skills).forEach((type) => {
  wrappedSkills[type] = wrapper(skills[type]);
});

let iobj: any = {};
Object.values(wrappedSkills).forEach((oarr: any) => {
  oarr.forEach(({ backgroundColor, alt }: any) => {
    iobj[alt] = { backgroundColor };
  });
});

const AboutPage: NextPage = () => {
  return (
    <Layout
      title="About Krutik Parikh, a Senior Software Engineer in the Canada"
      description="As a passionate software developer, I create amazing websites and web apps to make the internet a better place."
    >
      <ReactTooltip />

      <Container>
        <h1 className="headline text-3xl md:text-5xl lg:text-6xl mt-8">
          Hey, I&apos;m Krutik Parikh
        </h1>
        <h2 className="font-bold text-xl md:text-2xl mt-2">
          Senior Software Engineer from Canada
        </h2>
        <div className="grid md:grid-cols-3">
          <div className="col-span-2">
            <p className="mt-8">
              As a passionate Fullstack developer, I create amazing websites and
              web apps to make the internet a better place. I am an advocate for
              web performance and accessibility as well as a JAMstack enthusiast
              with experience in serverless technologies.
            </p>
            <p className="my-4">
              I am {new Date().getFullYear() - 1999} years young and have been a
              web developer for as long as I can think. The technologies I work
              with are JavaScript with a focus on the frameworks React.js,
              Next.js, Node, and Express. I use code not only to do my
              day-to-day job, but also to solve everyday problems I come across.
            </p>
            <p>
              When I am not writing code I love to spend time with my family and
              friends, having grown up in India 🇮🇳 and living in Canada 🇨🇦
              without the family being here is very difficult. I have been
              living here in Brampton, Canada since 2017 and loved every single
              day since. Apart from coding, i love to cook, watch shows and
              Indian Movies
            </p>
          </div>
          <div className="">
            <div
              className="rounded"
              style={{ width: "100%", height: "100%", position: "relative" }}
            >
              <Image
                src={`/assets/profile.jpg`}
                alt={`/assets/profile.jpg`}
                layout="fill"
                objectFit="contain"
              />
            </div>
          </div>
        </div>
        <hr className="mt-5" />
        <h2 className="headline mt-12 mb-4 text-4xl">Education</h2>
        <p className="mb-6">
          I am mostly self-taught, but here are some of the most relevant
          studies I have achieved:
        </p>

        <Education education={education} />
        {/* <div className="flex justify-center mt-8">
          <Button
            href="/"
            download={true}
            className="group flex gap-4 whitespace-nowrap items-center"
          >
            <div className="w-6 text-blue-500 group-hover:text-off-white dark:text-purple-500">
              <Icon icon="DOWNLOAD" />
            </div>
            <div className="block headline group-hover:text-off-white">
              Resume
            </div>
          </Button>
        </div> */}
        <hr className="mt-5" />

        {Object.getOwnPropertyNames(wrappedSkills).map((title, id) => (
          <div className="flex mt-5 flex-col" key={id}>
            <h1 className="text-lg font-semibold">{title}</h1>
            <div className="mt-2 flex flex-wrap md:flex-row gap-4">
              {wrappedSkills[title].map(({ alt, icon, backgroundColor }, i) => (
                <div className="flex flex-col" key={i}>
                  <div
                    data-tip={alt.replace("_", " ")}
                    style={{
                      backgroundColor,
                    }}
                    className="rounded-lg transition duration-150 ease-in-out"
                  >
                    <div
                      style={{ backgroundColor }}
                      className="m-1 mr-2 w-12 h-12 relative flex justify-center items-center rounded-full text-xl  uppercase"
                    >
                      {icon}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Container>
    </Layout>
  );
};

export default AboutPage;
